export function selectAll(filter_class, other_class) {
    if (other_class.length > 0) {
        filter_class += '.' + other_class;
    }
    var logs = document.querySelectorAll('.' + filter_class);
    for (var i = 0; i < logs.length; i++) {
        if (logs[i].checked) {
            logs[i].checked = false;
            removeFromList(logs[i].value, 'selector')
        }
        else {
            logs[i].checked = true;
            addToList(logs[i].value, 'selector')
        }
    }
}

export function addToList(id, list) {
    let input = document.getElementById(list);
    if (!input) {
        if (self !== top) {
            input = parent.document.getElementById(list);
        }
        if (!input) {
            console.log('Lista: ' + list + ' non trovata');
            return;
        }
    }
    // Write the ID in the input
    let actual_values;
    if (input.value.length === 0)
        actual_values = [];
    else
        actual_values = input.value.split(/,/);
    var length = actual_values.length;
    for (var i = 0; i < length; i++) {
        if ( parseInt(actual_values[i]) === id)
            return;
    }
    actual_values.push(id);
    input.value = actual_values.toString();

}

export function removeFromList(id, list) {
    let input = document.getElementById(list);
    if (!input) {
        console.log('Lista: ' + list + ' non trovata');
        return;
    }
    if (input.value.length === 0)
        return;
    let actual_values = input.value.split(/,/);
    var length = actual_values.length;
    var found = -1;
    for (var i = 0; i < length; i++) {
        if (actual_values[i] == id)
            found = i;
    }
    if (found == -1)
        return;
    actual_values.splice(found, 1);
    input.value = actual_values.toString();
}

export function togglePageSelector() {
    let id = this.value;
    var list = this.getAttribute('data-list');
    let selector = 'selector';
    if (list != null) {
        if (!document.getElementById(list))
            selector = list;
    }
    if (this.checked)
        addToList(id, selector);
    else
        removeFromList(id, selector)
}

export function removeElement(id, input) {
    removeFromList(id, input);
    var list = parent.document.getElementById('list_'+input); // unused
    var list_item = document.getElementById('list_item_' + id);
    list_item.parentNode.removeChild(list_item);
    console.log('script was passed here');
}

//Retro-compatibility function to work as new person in team
export function removeNewMembers(id) {
    console.log('error! debug this! (change function to removeElement)');
}

export function selectElement(id, input) {

    addToList(id, input);

    var list = parent.document.getElementById('list_'+input);
    // Write name and icon in the side list
    var li = document.createElement("li");
    var icon = document.createElement('i');
    icon.className = 'material-icons';
    icon.innerHTML = 'close';
    var remove_link = document.createElement('a');
    remove_link.href = 'javascript:removeElement('+id+',\''+input+'\')';
    remove_link.style.display = 'inline';
    remove_link.setAttribute('title', 'Rimuovi '+document.getElementById('el_name_'+id).innerHTML);
    remove_link.appendChild(icon);
    var name = document.createElement('p');
    name.innerHTML = document.getElementById('el_name_'+id).innerHTML;
    name.style.display = 'inline';
    li.appendChild(remove_link);
    li.appendChild(name);
    li.id = 'list_item_'+id;
    list.appendChild(li);
}

export function selectGroup(id, input) {

    if (id < 0)
    {
        return false;
    }

    var sel_name = parent.document.getElementById('sel_name');
    var sel_image = parent.document.getElementById('sel_image');
    var sel_region = parent.document.getElementById('sel_region');
    var sel_input = parent.document.getElementById(input);

    sel_input.value = id;

    var row_name = document.getElementById('group_'+id+'_name');
    var row_image = document.getElementById('group_'+id+'_image');
    var row_region = document.getElementById('group_'+id+'_regione');

    sel_name.innerHTML = row_name.innerHTML;
    sel_image.src = row_image.innerHTML;
    sel_region.innerHTML = row_region.innerHTML;

}

export function selectPerson(id, input) {

    addToList(id, input);

    let name = getPersonNameFromTag(id);

    var list = parent.document.getElementById('list_'+input);
    // Write name and remove icon in the side list
    var li = document.createElement("li");
    var icon = document.createElement('i');
    icon.className = 'material-icons';
    icon.innerHTML = 'close';
    var remove_link = document.createElement('a');
    remove_link.href = 'javascript:removeElement('+id+',\''+input+'\')';
    remove_link.style.display = 'inline';
    remove_link.setAttribute('title', 'Rimuovi '+ name);
    remove_link.appendChild(icon);
    var namep = document.createElement('p');
    namep.innerHTML = name;
    namep.style.display = 'inline';
    li.appendChild(remove_link);
    li.appendChild(namep);
    li.id = 'list_item_'+id;
    list.appendChild(li);
}

function getPersonNameFromTag(id) {
    let name;
    let nameContainer = document.getElementById('pers_name_'+id);
    if (!nameContainer) {
        return 'Membro '+id;
    } else {
        return nameContainer.innerText;
    }
}

export function addAll() {
    let input = document.getElementById('all_people');
    let input_name = input.getAttribute('data-input-name');
    let values = input.value.split(/,/);
    for (let i=0;i<values.length;i++) {
        selectPerson(values[i], input_name);
    }
}
